import PayPaymentPlanError from './PayPaymentPlanError';
class InvalidPaymentPlanId extends PayPaymentPlanError {
    paymentPlanId;
    constructor(paymentPlanId, options) {
        super('Payment plan id is invalid', options);
        this.paymentPlanId = paymentPlanId;
    }
}
export default InvalidPaymentPlanId;
